import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { messages } from './messages';
import RepeatButton from '../../../components/repeat-button';
import { useFulfillmentPlannerContext } from '../../context';

import style from './style.module.less';

const RateRefresher = ({ className, buttonClassName }) => {
  const { isRating, triggerRate, isTriggerRateDisabled } = useFulfillmentPlannerContext();
  return (
    <RepeatButton
      actionHandler={triggerRate}
      ariaLabelMessageDescriptor={messages.rateRefresherButtonAriaLabel}
      buttonClassName={classnames(style.button, buttonClassName)}
      className={classnames(style['repeat-icon'], className)}
      disabled={isTriggerRateDisabled}
      isSpinning={isRating}
    />
  );
};

RateRefresher.propTypes = {
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
};

export default RateRefresher;
